export var showInternalToolsTab = function (isRealmSetup, isLoaded, user, isAuthorizedForRealmSetup) {
    var _a;
    if (!isLoaded ||
        ((_a = user === null || user === void 0 ? void 0 : user.email) === null || _a === void 0 ? void 0 : _a.indexOf("@here.com", user.email.length - "@here.com".length)) === -1 ||
        (!isRealmSetup && !isAuthorizedForRealmSetup)) {
        return true;
    }
    else {
        return false;
    }
};
